angular
	.module 'App.Repository'
	.factory 'SalesTaxRepository', ['BaseRepository', (BaseRepository) ->
		class SalesTaxRepository extends BaseRepository
			@resource = '/sales_taxes'
			@isRestricted = true

			lookup: (address) ->
				query = @getQuery()
				query.addParameter('address', address)

				@find 'lookup', query

		return new SalesTaxRepository
	]
